import { FilledNewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const QuestIcon = ({ fill, color, className }: FilledNewIconProps) =>
  fill ? (
    <svg className={twMerge('size-[26px]', className)} width="100%" height="100%" viewBox="-4 -2 26 26" fill="none">
      <path
        d="M4.66671 21.8333L5.75004 14.25H0.333374L10.0834 0.166672H12.25L11.1667 8.83334H17.6667L6.83337 21.8333H4.66671Z"
        fill={color}
        stroke={color}
      />
    </svg>
  ) : (
    <svg className={twMerge('size-[26px]', className)} width="100%" height="100%" viewBox="-4 -2 26 26" fill="none">
      <path
        d="M4.66671 21.8333L5.75004 14.25H0.333374L10.0834 0.166672H12.25L11.1667 8.83334H17.6667L6.83337 21.8333H4.66671Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
